import React from 'react';
import { Controller } from 'react-hook-form';
import { 
  TextField, RadioGroup, FormControlLabel, Radio, 
  Checkbox, FormGroup, Typography, Select, MenuItem, FormControl 
} from '@mui/material';

const inputStyles = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '10px',
    bgcolor: '#fcfcfd',
    transition: 'all 0.2s',
    '&:hover': { bgcolor: '#f2f4f7' },
    '&.Mui-focused': { bgcolor: '#fff' }
  }
};

const FormField = ({ question, control, error }) => {
  const { id, type, options, required } = question;
  const name = `question_${id}`;

  switch (type) {
    case 'single_choice':
      return (
        <Controller
          name={name}
          control={control}
          rules={{ required }}
          render={({ field }) => (
            <RadioGroup {...field} row>
              {options.map((opt, i) => (
                <FormControlLabel key={i} value={opt} control={<Radio size="small" />} label={<Typography variant="body2">{opt}</Typography>} />
              ))}
            </RadioGroup>
          )}
        />
      );

    case 'multiple_choice':
      return (
        <FormGroup row>
          {options.map((opt, i) => (
            <Controller
              key={i}
              name={`${name}.${opt}`}
              control={control}
              render={({ field }) => (
                <FormControlLabel
                  control={<Checkbox {...field} checked={field.value || false} size="small" />}
                  label={<Typography variant="body2">{opt}</Typography>}
                />
              )}
            />
          ))}
        </FormGroup>
      );

    case 'dropdown':
      return (
        <Controller
          name={name}
          control={control}
          rules={{ required }}
          render={({ field }) => (
            <FormControl fullWidth size="small" sx={inputStyles} error={!!error}>
              <Select {...field} displayEmpty>
                <MenuItem value="" disabled>Select Option</MenuItem>
                {options.map((opt, i) => <MenuItem key={i} value={opt}>{opt}</MenuItem>)}
              </Select>
            </FormControl>
          )}
        />
      );

    default:
      return (
        <Controller
          name={name}
          control={control}
          rules={{ required }}
          render={({ field }) => (
            <TextField 
              {...field} 
              fullWidth 
              size="small" 
              multiline={type === 'long_text'} 
              rows={type === 'long_text' ? 3 : 1}
              sx={inputStyles}
              error={!!error}
            />
          )}
        />
      );
  }
};

export default FormField;